import { useState } from "react";
import styles from "./showLess.module.scss";

// tslint:disable-next-line:typedef
export default function ShowLess({ children, className = "" }) {
  const [more, setMore] = useState(false);

  return (
    <div
      className={`${className} ${styles.showLess} ${more ? styles.more : ""}`}
    >
      {children}
      {/* eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */}
      <div className={styles.toggle} onClick={() => setMore(!more)}>
        Show {more ? "less" : "more"} {more ? "↑" : "↓"}
      </div>
    </div>
  );
}
